import styled from "@emotion/styled";

interface ImageProps {
  width: string;
  height: string;
}

export const StyledImage = styled("img")<ImageProps>`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  margin-bottom: 10px;
  border-radius: 10px;
  object-fit: cover;
`;
